<script lang="ts">
    import src from './svg/route-status-delivery.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    import { _ } from 'svelte-i18n';

    export let count: number = 0;
    export let total: number = 0;
    export let showCount: boolean = false;
    export let showPercent: boolean = true;
    export let scale: number = 1;
    export let title: string = '';

    let percent: number = 0;
    let defaultTitle: string = '';

    $: {
        percent = total > 0 ? Math.round((100 * count) / total) : 0;
        defaultTitle = $_('route-realisation-deliveries', {
            values: { count: count, total: total, percent: percent },
        });
    }
</script>

<div class="container" title={defaultTitle}>
    <!--    <TemplateIcon {src} {scale} alt={title || defaultTitle} hover={title || defaultTitle} on:click />-->
    {#if showCount && count > 0}
        <span class="count">({count})</span>
    {/if}
    {#if showPercent}
        <span class="count">{percent}%</span>
    {/if}
</div>

<style>
    .container {
        display: flex;
        /*cursor: pointer;*/
    }
    .count {
        margin-left: 3px;
        margin-right: 5px;
    }
</style>
